function isMobileUA() {
    const ua = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}
function isSafariUA() {
    const ua = navigator.userAgent;
    return /Safari/i.test(ua) && !/Chrome|CriOS|Chromium|Edg|OPR|Firefox|FxiOS/i.test(ua);
}
function isMetaMaskInAppBrowser() {
    const ua = navigator.userAgent;
    if (/MetaMask/i.test(ua))
        return true;
    if (isMobileUA() && typeof window !== 'undefined' && window.ethereum?.isMetaMask) {
        if (window.ethereum?._metamask)
            return true;
    }
    return false;
}
function isStandaloneMode() {
    if (window.matchMedia('(display-mode: standalone)').matches)
        return true;
    if (navigator.standalone === true)
        return true;
    if (document.referrer.includes('android-app://'))
        return true;
    return false;
}
function getBrowserName() {
    const ua = navigator.userAgent;
    if (/MetaMask/i.test(ua))
        return 'MetaMask';
    if (/Edg\//i.test(ua))
        return 'Edge';
    if (/OPR\//i.test(ua))
        return 'Opera';
    if (/SamsungBrowser/i.test(ua))
        return 'Samsung';
    if (/Firefox|FxiOS/i.test(ua))
        return 'Firefox';
    if (/CriOS/i.test(ua))
        return 'Chrome (iOS)';
    if (/Chrome/i.test(ua) && !/Edg/i.test(ua))
        return 'Chrome';
    if (isSafariUA())
        return 'Safari';
    return 'Unknown';
}
export function detectPlatform() {
    const mobile = isMobileUA();
    const safari = isSafariUA();
    const metamask = isMetaMaskInAppBrowser();
    const standalone = isStandaloneMode();
    const hasExtension = typeof window !== 'undefined' && !!window.ethereum;
    const browserName = getBrowserName();
    let type;
    if (metamask && mobile) {
        type = 'mobile-metamask';
    }
    else if (mobile && standalone) {
        type = 'mobile-pwa';
    }
    else if (mobile && safari) {
        type = 'mobile-safari';
    }
    else if (mobile) {
        type = 'mobile-standard';
    }
    else if (!mobile && safari) {
        type = 'desktop-safari';
    }
    else {
        type = 'desktop-standard';
    }
    return {
        type,
        isMobile: mobile,
        isDesktop: !mobile,
        isSafari: safari,
        isMetaMaskBrowser: metamask,
        hasWalletExtension: hasExtension,
        canInstallPwa: mobile && !standalone && !metamask,
        isStandalone: standalone,
        browserName,
    };
}
